
<template>
    <div class="report-arrow">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" :fill="fill" :stroke="stroke"
            viewBox="0 0 22.13 28.55" style="enable-background:new 0 0 22.13 28.55;" xml:space="preserve">
        <path d="M1.63,4.24l0,19.96c0,2.52,2.32,4.07,4.13,2.77l13.87-9.98c1.75-1.26,1.75-4.28,0-5.54L5.75,1.47
            C3.94,0.17,1.63,1.72,1.63,4.24z"/>
        </svg>
    </div>
</template>

<script>

export default {
    data:() => ({colors: ''}),
    props:['fill', 'stroke'],
    created(){
        this.colors = JSON.parse(localStorage.getItem('colors'))
        // console.log("_____FILL:", this.fill)
    }
}
</script>
<style lang="scss" scoped>
</style>